
import bugsnag from '@bugsnag/js'
import bugsnagReact from '@bugsnag/plugin-react'

const bugSnagHelper = (error) => {
  //const bugsnag = new Client("3a27b7bdd3921f605488e155c09a81d1");
  //bugSnagHelper(error);
  console.log('bugsnagged error is ', error);
}
export default bugSnagHelper